'use strict';

exports.__esModule = true;
var presetsTypes = exports.presetsTypes = {
  DEFAULT: 'DEFAULT',
  DS: 'DS',
  EDITOR: 'EDITOR',
  OOI: 'OOI',
  BOLT: 'BOLT',
  MOBILE: 'MOBILE'
};